import { useCallback, useEffect, useState } from 'react';
import { clearMarkCommand, getActiveMark, setMarkCommand } from '../utils/markUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-ignore no types
import ColorPickerPopoverBody from 'react-colorpicker/popover/ColorPickerPopoverBody';
import UITextToolbarColorDropdown from 'rich-text-lib/components/editor/UITextToolbarColorDropdown';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { Tracker } from '../../utils/usageTracker';
import { PM_CHANGE_COLOR } from '../constants/events';
import { APPLY_COLOR_POPOVER } from 'rich-text-lib/constants/usageTracking';
import { isValidColorHex } from 'UIComponents/utils/propTypes/color';
import { convertRgbStringToHex } from 'rich-text-lib/utils/color';
import { HighlightIcon } from 'foundations-assets/icons/components/HighlightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const setHighlight = attrs => setMarkCommand(schema => schema.marks.highlight, attrs);
export const clearHighlight = () => clearMarkCommand(schema => schema.marks.highlight);
const defaultHighlightColor = '#FFFFFF';
export default function HighlightMark() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const [colorValue, setColorValue] = useState(defaultHighlightColor);
  useEffect(() => {
    const activeHighlightColor = getActiveMark(editorState, editorState.schema.marks.highlight);
    const color = activeHighlightColor ? activeHighlightColor.attrs.color : null;
    if (!color) {
      setColorValue(defaultHighlightColor);
      return;
    }
    try {
      setColorValue(convertRgbStringToHex(color));
    } catch (_e) {
      if (isValidColorHex(color)) {
        setColorValue(color);
      } else {
        setColorValue(defaultHighlightColor);
      }
    }
  }, [editorState, setEditorState, setColorValue]);
  const applyHighlight = useCallback(evt => {
    setHighlight({
      color: evt.target.value.color
    })(editorState, tr => {
      setEditorState(editorState.apply(tr));
    });
    setColorValue(evt.target.value.color);
    Tracker.track(PM_CHANGE_COLOR, {
      action: APPLY_COLOR_POPOVER,
      format: 'hilitecolor'
    });
  }, [editorState, setEditorState, setColorValue]);
  const resetHighlight = useCallback(() => {
    clearHighlight()(editorState, tr => {
      setEditorState(editorState.apply(tr));
    });
    setColorValue(defaultHighlightColor);
    Tracker.track(PM_CHANGE_COLOR, {
      action: APPLY_COLOR_POPOVER,
      format: 'hilitecolor'
    });
  }, [editorState, setEditorState, setColorValue]);
  return /*#__PURE__*/_jsx(UITextToolbarColorDropdown, {
    "data-test-id": "text-highlight-dropdown",
    color: {
      color: colorValue,
      alpha: 100
    },
    DropdownContent: ColorPickerPopoverBody,
    icon: "highlight",
    Icon: HighlightIcon,
    menuWidth: 300,
    onColorChange: applyHighlight,
    onResetClick: resetHighlight,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.textHighlight"
    })
  });
}